<template>
  <div>
    <v-row class="my-1">
      <v-col class="py-1" cols="12" sm="6" md="4" lg="4">
        <DenseActionCard title="Justificatif" description="Télécharger le justificatif de paiement pour cette commande"
          icon="mdi-download" :toUrl="url_justificatif"></DenseActionCard>

      </v-col>
      <v-col class="py-1" cols="12" sm="6" md="4" lg="4">
        <DenseActionCard title="Mail de confirmation" :description="'Renvoyer le mail à ' + mainStore.authUser.userMail"
          icon="mdi-email-plus" @onClick="resend_confirm_email()"></DenseActionCard>
      </v-col>
      <v-col class="py-1" cols="12" sm="6" md="4" lg="4">
        <DenseActionCard title="Ajout d'options" description="Ajouter des options aux inscrits de cette commande"
          icon="mdi-basket-plus" :toPage="{ name: 'AddOptions', params: { id_commande: commande.id } }">
        </DenseActionCard>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { mapStores } from "pinia";
import { useMainStore } from "@/stores/mainStore";
import UserService from "@/services/user.service.js";
export default {
  name: 'Actions_Card_Commande',
  props: ["item"],
  data() {
    return {
      commande: {},
      base_url: process.env.VUE_APP_API_BASE,
    };
  },
  computed: {
    ...mapStores(useMainStore),
    url_justificatif() {

      return this.base_url + 'user/commande/justificatif/download.php?id=' + this.commande.id + '&token=' + this.mainStore.authUser.userData.token;
    }
  },

  methods: {
    async resend_confirm_email() {
      let response = await UserService.sendCommandeConfirmationEmail(this.commande.uuid);
      this.mainStore.notification.send(response);
    },
  },
  created() {
    this.commande = this.item;
  },
};
</script>

<style lang="scss" scoped></style>